(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[176],{

/***/ 3744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12C7.7 12 7.5 11.8 7.5 11.5V6.5C7.5 6.2 7.7 6 8 6C8.3 6 8.5 6.2 8.5 6.5V11.5C8.5 11.8 8.3 12 8 12ZM7.5 4.5C7.5 4.8 7.7 5 8 5C8.3 5 8.5 4.8 8.5 4.5C8.5 4.2 8.3 4 8 4C7.7 4 7.5 4.2 7.5 4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    fill: "currentColor"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgInfo);

/***/ }),

/***/ 9997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ apiConstants; },
/* harmony export */   "v": function() { return /* binding */ dixaRestApiEndpoints; }
/* harmony export */ });
var dixaRestApiEndpoints = {
  protocol: 'https',
  subdomain: 'api',
  domain: 'dixa.io',
  production: 'https://api.dixa.io'
};
var apiConstants = {
  ipinfo: "https://ipinfo.io/?token=4948ba2d266f92"
};

/***/ }),

/***/ 8007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ customFetch; }
/* harmony export */ });
/* harmony import */ var _runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9499);
/* harmony import */ var _runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29);
/* harmony import */ var _runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Custom fetch function that can be used to fetch / post data from a remote source.
 * It default to send a GET request to the remote source with header application/json.
 */
var customFetch = /*#__PURE__*/function () {
  var _ref = (0,_runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(input, init) {
    var res, error;
    return _runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(input, _objectSpread({
              headers: _objectSpread({
                'Content-Type': 'application/json'
              }, init === null || init === void 0 ? void 0 : init.headers)
            }, init));

          case 2:
            res = _context.sent;

            if (res.ok) {
              _context.next = 11;
              break;
            }

            error = new Error('An error occurred while fetching the data.'); // Attach extra info to the error object.

            _context.next = 7;
            return res.json();

          case 7:
            error.info = _context.sent;
            error.status = res.status;
            error.statusText = res.statusText;
            throw error;

          case 11:
            return _context.abrupt("return", res.json());

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function customFetch(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 3602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports defaultValidationErrorHandler, setTypewriterOptions, linkToEmailProviderClicked, signinMagiclinkFormSubmitted, signinWithAnotherEmailClicked, signupSucceeded */
/* harmony import */ var _runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_runner_work_accounts_website_accounts_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * This client was automatically generated by Segment Typewriter. ** Do Not Edit **
 */

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
var defaultValidationErrorHandler = function defaultValidationErrorHandler(message, violations) {
  var msg = JSON.stringify({
    type: 'Typewriter JSON Schema Validation Error',
    description: "You made an analytics call (".concat(message.event, ") using Typewriter that doesn't match the ") + 'Tracking Plan spec.',
    errors: violations
  }, undefined, 2);
  console.warn(msg);
};

var analytics = function analytics() {
  return window.analytics;
};
/** Options to customize the runtime behavior of a Typewriter client. */


/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
function setTypewriterOptions(options) {
  analytics = options.analytics ? function () {
    return options.analytics || window.analytics;
  } : analytics;
}
/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */

function withTypewriterContext() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, message), {}, {
    context: _objectSpread(_objectSpread({}, message.context || {}), {}, {
      typewriter: {
        language: 'typescript',
        version: '7.4.1'
      }
    })
  });
}
/**
 * @typedef LinkToEmailProviderClicked
 * @property {string} provider -
 */

/**
 * @typedef SigninMagiclinkFormSubmitted
 * @property {string} email - The email thats signing in.
 */

/**
 * @typedef SignupSucceeded
 * @property {string} company_name - The name of the company that has signed up
 * @property {string} domain - The domain claimed
 * @property {string} email - The email of the person whom signed up
 * @property {string} full_name - The name of the person whom signed up
 * @property {boolean} has_accepted_marketing - If the person has accepted marketing
 * @property {string} phone_number - The phone number for the person whom signed up
 */

/**
 * When the user clicks a link that quickly takes them to their email provider. eg. Gmail
 *
 * @param {LinkToEmailProviderClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */


function linkToEmailProviderClicked(props, options, callback) {
  var a = analytics();

  if (a) {
    a.track('Link To Email Provider Clicked', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * When the user submits the sign in form
 *
 * @param {SigninMagiclinkFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */

function signinMagiclinkFormSubmitted(props, options, callback) {
  var a = analytics();

  if (a) {
    a.track('Signin Magiclink Form Submitted', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * When the user clicks the links that navigates them back to the signin page, likely because they had a mistake in their email
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */

function signinWithAnotherEmailClicked(props, options, callback) {
  var a = analytics();

  if (a) {
    a.track('Signin With Another Email Clicked', props || {}, withTypewriterContext(options), callback);
  }
}
/**
 * When a person signs up to a trial accounts
 *
 * @param {SignupSucceeded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */

function signupSucceeded(props, options, callback) {
  var a = analytics();

  if (a) {
    a.track('Signup Succeeded', props || {}, withTypewriterContext(options), callback);
  }
}
var clientAPI = {
  /**
   * Updates the run-time configuration of this Typewriter client.
   *
   * @param {TypewriterOptions} options - the options to upsert
   *
   * @typedef {Object} TypewriterOptions
   * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setTypewriterOptions: setTypewriterOptions,

  /**
   * When the user clicks a link that quickly takes them to their email provider. eg. Gmail
   *
   * @param {LinkToEmailProviderClicked} props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  linkToEmailProviderClicked: linkToEmailProviderClicked,

  /**
   * When the user submits the sign in form
   *
   * @param {SigninMagiclinkFormSubmitted} props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  signinMagiclinkFormSubmitted: signinMagiclinkFormSubmitted,

  /**
   * When the user clicks the links that navigates them back to the signin page, likely because they had a mistake in their email
   *
   * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  signinWithAnotherEmailClicked: signinWithAnotherEmailClicked,

  /**
   * When a person signs up to a trial accounts
   *
   * @param {SignupSucceeded} props - The analytics properties that will be sent to Segment.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  signupSucceeded: signupSucceeded
};
/* harmony default export */ __webpack_exports__["ZP"] = (new Proxy(clientAPI, {
  get: function get(target, method) {
    if (typeof method === 'string' && target.hasOwnProperty(method)) {
      return target[method];
    }

    return function () {
      console.warn("\u26A0\uFE0F  You made an analytics call (".concat(String(method), ") that can't be found. Either:\n    a) Re-generate your typewriter client: `npx typewriter`\n    b) Add it to your Tracking Plan: https://app.segment.com/dixahq/protocols/tracking-plans/rs_28L0C1NO34nh4vcR2j8txrqC9bx"));
      var a = analytics();

      if (a) {
        a.track('Unknown Analytics Call Fired', {
          method: method
        }, withTypewriterContext());
      }
    };
  }
}));

/***/ }),

/***/ 9662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getDixaRestAPIUrl; }
/* harmony export */ });
/* harmony import */ var _config_constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9997);

var getDixaRestAPIUrl = function getDixaRestAPIUrl() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$version = options.version,
      version = _options$version === void 0 ? 1 : _options$version,
      backendDomain = options.backendDomain;

  if (backendDomain) {
    return "".concat(_config_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .dixaRestApiEndpoints.protocol */ .v.protocol, "://").concat(_config_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .dixaRestApiEndpoints.subdomain */ .v.subdomain, ".").concat(backendDomain, "/v").concat(version);
  }

  return "".concat(_config_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .dixaRestApiEndpoints.protocol */ .v.protocol, "://").concat(_config_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .dixaRestApiEndpoints.subdomain */ .v.subdomain, ".").concat(_config_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .dixaRestApiEndpoints.domain */ .v.domain, "/v").concat(version);
};

/***/ }),

/***/ 191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ isClientRuntime; }
/* harmony export */ });
var isClientRuntime = function isClientRuntime() {
  return true;
};

/***/ }),

/***/ 46:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SigninPage": function() { return /* binding */ signin_SigninPage; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ signin; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/lib/utils/isClientRuntime.ts
var isClientRuntime = __webpack_require__(191);
;// CONCATENATED MODULE: ./src/lib/utils/isInElectron.ts
/* provided dependency */ var process = __webpack_require__(4155);
// This is a rewrite of https://github.com/cheton/is-electron/blob/master/index.js

/**
 * is Electron runtime
 *
 * Returns true if the app is running inside an Electron application.
 *
 * @returns {boolean}
 */

var isElectronRuntime = function isElectronRuntime() {
  // Electron renderer process
  if ((0,isClientRuntime/* isClientRuntime */.b)() && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true;
  } // Main process


  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
    return true;
  } // Detect the user agent when the `nodeIntegration` option is set to false


  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
    return true;
  }

  return false;
};
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/designSystem/index.tsx + 327 modules
var designSystem = __webpack_require__(8818);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./src/components/mainContent/index.tsx + 3 modules
var mainContent = __webpack_require__(4218);
// EXTERNAL MODULE: ./src/config/constants/definedIntlMessages.ts
var definedIntlMessages = __webpack_require__(8918);
// EXTERNAL MODULE: ./src/designSystem/icons/info.svg
var info = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/designSystem/icons/error.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgError = function SvgError(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM10.8536 5.14645C11.0488 5.34171 11.0488 5.65829 10.8536 5.85355L8.70711 8L10.8536 10.1464C11.0488 10.3417 11.0488 10.6583 10.8536 10.8536C10.6583 11.0488 10.3417 11.0488 10.1464 10.8536L8 8.70711L5.85355 10.8536C5.65829 11.0488 5.34171 11.0488 5.14645 10.8536C4.95118 10.6583 4.95118 10.3417 5.14645 10.1464L7.29289 8L5.14645 5.85355C4.95118 5.65829 4.95118 5.34171 5.14645 5.14645C5.34171 4.95118 5.65829 4.95118 5.85355 5.14645L8 7.29289L10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645Z",
    fill: "currentColor"
  })));
};

/* harmony default export */ var icons_error = (SvgError);
;// CONCATENATED MODULE: ./src/config/constants/shared.ts
var emailCacheKey = '__cached-email';
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/pages/signin/signinPage/signinPage.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var SigninPage = function SigninPage(_ref) {
  var _errors$email;

  var isInvalidToken = _ref.isInvalidToken,
      onSubmit = _ref.onSubmit,
      isSubmitting = _ref.isSubmitting,
      error = _ref.error;
  var intl = (0,useIntl/* default */.Z)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      setFocus = _useForm.setFocus,
      setValue = _useForm.setValue,
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  (0,react.useEffect)(function () {
    // Focus the email field on init
    setFocus('email'); // Set the email value from the cache if present

    if ((0,isClientRuntime/* isClientRuntime */.b)()) {
      var cachedEmail = window.localStorage.getItem(emailCacheKey);

      if (cachedEmail) {
        setValue('email', cachedEmail);
      }
    }
  }, [setFocus, setValue]);

  var getBanner = function getBanner() {
    if (isInvalidToken && !error) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(designSystem/* Banner */.jL, {
        role: "alert",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(info/* default */.Z, {}),
        title: intl.formatMessage(definedIntlMessages/* definedIntlMessages.invalidTokenTitle */.X.invalidTokenTitle),
        description: intl.formatMessage(definedIntlMessages/* definedIntlMessages.invalidTokenDescription */.X.invalidTokenDescription),
        "data-testid": "invalidTokenText"
      });
    }

    if (error) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(designSystem/* Banner */.jL, {
        role: "alert",
        colorScheme: "red",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_error, {}),
        title: error.title,
        description: error.description
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(mainContent/* MainContent */.M, {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
      id: "ivRvei",
      defaultMessage: [{
        "type": 0,
        "value": "Log in to Dixa"
      }]
    }),
    metaTitle: intl.formatMessage(definedIntlMessages/* definedIntlMessages.pageSigninTitle */.X.pageSigninTitle),
    metaDescription: intl.formatMessage(definedIntlMessages/* definedIntlMessages.defaultMetaDescription */.X.defaultMetaDescription),
    lead: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
      id: "5UfQIF",
      defaultMessage: [{
        "type": 0,
        "value": "Enter your email and we’ll send a magic link to log in."
      }]
    }),
    banner: getBanner(),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(designSystem/* VStack */.gC, {
      as: "form",
      align: "stretch",
      spacing: "4",
      onSubmit: handleSubmit(onSubmit),
      autoComplete: "on",
      "aria-label": "Sign in form",
      "data-testid": "signin-form",
      noValidate: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(designSystem/* FormControl */.NI, {
        isInvalid: errors === null || errors === void 0 ? void 0 : errors.email,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(designSystem/* FormLabel */.lX, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "sy+pv5",
            defaultMessage: [{
              "type": 0,
              "value": "Email"
            }]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(designSystem/* Input */.II, _objectSpread({
          type: "email",
          autoComplete: "email",
          disabled: isSubmitting,
          "aria-required": true
        }, register('email', {
          required: {
            value: true,
            message: intl.formatMessage(definedIntlMessages/* definedIntlMessages.invalidEmailRequired */.X.invalidEmailRequired)
          },
          pattern: {
            value: /\S+@\S+\.\S+/,
            message: intl.formatMessage(definedIntlMessages/* definedIntlMessages.invalidEmailPattern */.X.invalidEmailPattern)
          }
        }))), /*#__PURE__*/(0,jsx_runtime.jsx)(designSystem/* FormErrorMessage */.J1, {
          children: errors === null || errors === void 0 ? void 0 : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(designSystem/* Button */.zx, {
        type: "submit",
        width: "100%",
        isLoading: isSubmitting,
        colorScheme: "purple",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "SQJto2",
          defaultMessage: [{
            "type": 0,
            "value": "Sign in"
          }]
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/pages/signin/signinPage/index.tsx

// EXTERNAL MODULE: ./src/lib/segment/generated/index.ts
var generated = __webpack_require__(3602);
;// CONCATENATED MODULE: ./src/config/constants/routes.ts
/* provided dependency */ var routes_process = __webpack_require__(4155);
var localeRoutePath = routes_process.env.NEXT_PUBLIC_LOCALE ? routes_process.env.NEXT_PUBLIC_LOCALE + '/' : '';
// EXTERNAL MODULE: ./src/lib/utils/getDixaApiUrl.ts
var getDixaApiUrl = __webpack_require__(9662);
// EXTERNAL MODULE: ./src/components/mainLayout/index.tsx + 1 modules
var mainLayout = __webpack_require__(4245);
// EXTERNAL MODULE: ./src/lib/fetchers/customFetch.ts
var customFetch = __webpack_require__(8007);
;// CONCATENATED MODULE: ./src/pages/signin/index.tsx




function signin_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function signin_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { signin_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { signin_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var __N_SSG = true;
function signin_SigninPage() {
  var _router$query;

  var router = (0,next_router.useRouter)();
  var intl = (0,useIntl/* default */.Z)();

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var _useState2 = (0,react.useState)(),
      error = _useState2[0],
      setError = _useState2[1];

  var _ref = (_router$query = router === null || router === void 0 ? void 0 : router.query) !== null && _router$query !== void 0 ? _router$query : {},
      invalidToken = _ref.invalid_token,
      backendDomain = _ref['backend-domain'];

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var rootPath, rootPathIsCustomBaseHref, endpoint, returnUri, payload, _error, _ref3, _error$statusText;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              setError(undefined); // Get base url if it's eg. branch name

              rootPath = window.location.pathname.split('/')[1];
              rootPathIsCustomBaseHref = rootPath !== 'signin';
              _context.prev = 4;
              endpoint = "".concat((0,getDixaApiUrl/* getDixaRestAPIUrl */.K)({
                backendDomain: backendDomain
              }), "/login/delivery");
              returnUri = "".concat(window.location.origin, "/").concat(rootPathIsCustomBaseHref ? rootPath + '/' : '').concat(localeRoutePath, "signin/magiclink-verify?email=").concat(data.email).concat(backendDomain ? '&backend-domain=' + backendDomain : '');
              payload = {
                send_to: data.email,
                delivery: isElectronRuntime() ? 'desktop' : 'email',
                return_uri: returnUri
              }; // Send request to Dixa API

              _context.next = 10;
              return (0,customFetch/* customFetch */.r)(endpoint, {
                method: 'POST',
                body: JSON.stringify(payload)
              });

            case 10:
              // Cache the users email for future logins
              if ((0,isClientRuntime/* isClientRuntime */.b)()) {
                window.localStorage.setItem(emailCacheKey, data.email);
              } // Track that the user has succesfully claimed a login


              generated/* default.signinMagiclinkFormSubmitted */.ZP.signinMagiclinkFormSubmitted({
                email: data.email
              }); // Redirect to success page

              router.push({
                pathname: '/signin/magiclink-sent',
                query: signin_objectSpread({
                  email: data.email
                }, backendDomain ? {
                  'backend-domain': backendDomain
                } : {})
              });
              _context.next = 20;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](4);
              _error = _context.t0;

              if (_error.status === 500) {
                setError({
                  title: intl.formatMessage(definedIntlMessages/* definedIntlMessages.networkError500title */.X.networkError500title),
                  description: intl.formatMessage(definedIntlMessages/* definedIntlMessages.networkError500Description */.X.networkError500Description)
                });
              } else {
                setError({
                  title: "".concat(intl.formatMessage(definedIntlMessages/* definedIntlMessages.networkError */.X.networkError)).concat(_error.status ? ':' + _error.status : ''),
                  description: (_ref3 = (_error$statusText = _error.statusText) !== null && _error$statusText !== void 0 ? _error$statusText : _error.message) !== null && _ref3 !== void 0 ? _ref3 : ''
                });
              }

              setIsSubmitting(false);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 15]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SigninPage, {
    isInvalidToken: !!invalidToken,
    onSubmit: onSubmit,
    error: error,
    isSubmitting: !!isSubmitting
  });
}

signin_SigninPage.getLayout = function (page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(mainLayout/* MainLayout */.Z, {
    children: page
  });
};

/* harmony default export */ var signin = (signin_SigninPage);

/***/ }),

/***/ 81:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin",
      function () {
        return __webpack_require__(46);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [387,53,241,774,888,179], function() { return __webpack_exec__(81); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);